import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Grid, Divider, Box, Chip, Paper
} from '@mui/material';
import { 
  AssignmentTurnedIn, 
  CalendarMonth, 
  MeetingRoom, 
  Update,
  LocalHospital
} from '@mui/icons-material';
import dayjs from 'dayjs';

const DetalleAltaModal = ({ open, onClose, hospitalizacion }) => {
  if (!hospitalizacion) return null;

  // Estilo para las etiquetas de los campos
  const Label = ({ icon, text }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, color: 'text.secondary' }}>
      {icon}
      <Typography variant="caption" fontWeight="bold" sx={{ textTransform: 'uppercase' }}>
        {text}
      </Typography>
    </Box>
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ bgcolor: '#f8fafc', display: 'flex', alignItems: 'center', gap: 1 }}>
        <AssignmentTurnedIn color="primary" />
        Resumen de Cierre de Caso
      </DialogTitle>
      
      <DialogContent dividers>
        <Grid container spacing={3} sx={{ mt: 0.5 }}>
          
          {/* Estado Actual */}
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <Chip 
                label={`ESTADO FINAL: ${hospitalizacion.estado?.toUpperCase()}`} 
                color="info" 
                variant="filled"
                sx={{ fontWeight: 'bold', px: 2 }}
              />
            </Box>
          </Grid>

          {/* Diagnóstico Definitivo */}
          <Grid item xs={12}>
            <Label icon={<LocalHospital fontSize="small" />} text="Diagnóstico Definitivo" />
            <Paper variant="outlined" sx={{ p: 2, bgcolor: '#fffdfa', borderStyle: 'dashed' }}>
              <Typography variant="body1">
                {hospitalizacion.diagnostico_definitivo || "No se registró diagnóstico final."}
              </Typography>
            </Paper>
          </Grid>

          {/* Fechas */}
          <Grid item xs={6}>
            <Label icon={<CalendarMonth fontSize="small" />} text="Fecha de Alta / Fin" />
            <Typography variant="body2" fontWeight="500">
              {hospitalizacion.fecha_egreso 
                ? dayjs(hospitalizacion.fecha_egreso).format('DD/MM/YYYY HH:mm') 
                : '—'}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Label icon={<Update fontSize="small" />} text="Última Actualización" />
            <Typography variant="body2" fontWeight="500">
              {hospitalizacion.updated_at 
                ? dayjs(hospitalizacion.updated_at).format('DD/MM/YYYY HH:mm') 
                : '—'}
            </Typography>
          </Grid>

          {/* Ubicación */}
          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <MeetingRoom color="action" />
              <Typography variant="body2">
                <strong>Jaula / Box de egreso:</strong> {hospitalizacion.id_jaula || "Sin asignar"}
              </Typography>
            </Box>
          </Grid>

        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 2, bgcolor: '#f8fafc' }}>
        <Button onClick={onClose} variant="contained" color="inherit">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetalleAltaModal;